import React from "react";
import { FaDownload } from "react-icons/fa";
import Slide from "react-reveal/Slide";
import Zoom from "react-reveal/Zoom";
import Typewriter from "typewriter-effect";
import Banner from "../../Assets/Images/banner.svg";
import "./SuperHero.scss";
import PDF from "../../Assets/PDFs/resume-me.pdf";

const SuperHero = () => {
  return (
    <Slide left>
      <div className="superhero">
        <div className="container custom-height d-flex align-items-center justify-content-center">
          <div className="row">
            <div className="col-md-6 mb-5 custom-margin-top">
              <h1 className="display-3 fw-bold custom-font">
                Hi I'm <span className="name">Rafi Ferdos</span>
              </h1>
              <span className="fs-2">
                <Typewriter
                  options={{
                    autoStart: true,
                    loop: true,
                    strings: [
                      "MERN-Stack Developer",
                      "Web Developer",
                      "Self-Motivated Programmer",
                      "JavaScript Developer",
                      "React-Developer",
                    ],
                  }}
                />
              </span>
              <Zoom left cascade>
                <p className="about-me-text mt-5">
                  A self-motivated and energetic web developer. In today's world
                  I am constantly developing my skills to keep up with the
                  latest technology. I work hard to keep my confidence level up
                  and make a fame in this modern world. I'm what I am.
                </p>
              </Zoom>
              <Slide left>
                <a href={PDF} target="_blank" rel="noreferrer">
                  <button className="resume-button btn mt-4 px-5 py-3">
                    Resume
                    <FaDownload className="download-icon" />
                  </button>
                </a>
              </Slide>
            </div>
            <Zoom left>
              <div className="col-md-6 d-flex align-items-center justify-content-center">
                <div className="image">
                  <img className="my-image" src={Banner} alt="" />
                </div>
              </div>
            </Zoom>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default SuperHero;
